"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "branzi": {
    "e1a67bea": [{
      "hkey": "9e32d8db",
      "slug": "branzi",
      "name": "Branzi",
      "primary": true,
      "skipSearch": false
    }],
    "cagnoli": [{
      "hkey": "9e32d8db",
      "slug": "branzi",
      "name": "Branzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24419081": [{
      "hkey": "58751702",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ripe": [{
      "hkey": "58751702",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "branzi"
    }],
    "c55b58fa": [{
      "hkey": "9e32d8db",
      "slug": "branzi",
      "name": "Branzi",
      "primary": true,
      "skipSearch": false
    }],
    "rivioni": [{
      "hkey": "9e32d8db",
      "slug": "branzi",
      "name": "Branzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;